import React, { useState } from 'react';
import { pathJoin } from '../../../services/api';
import { useParams } from '../../../services/routing/useRouteInfo';
import { Delete, Edit } from '../../shared/actions/actionButtons';
import { ViewLayout } from '../../shared/cardLayouts/viewLayout';
import { AutoSizeCard } from '../../shared/cards/autoSizeCard';
import { NoteCard } from '../../shared/cards/noteCard';
import { StatCard } from '../../shared/cards/statCard';
import { Telephone } from '../../shared/links/telephone';
import { LoadText } from '../../shared/load/loadText';
import { View } from '../../shared/view/view';
import { AuthorizedUserAuditLog } from './authorizedUserAuditLogList';
import { AuthorizedUserList } from './authorizedUserList';
import { SystemStatus } from './systemStatus';
import { Email } from '../../shared/links/email';
import { SYSTEM, USER } from '../../../permissions';

import styles from './systemView.module.css';
import { useHasPermission } from '../../../services/auth/auth';


export const SystemView = () => {

    let { id } = useParams();
    const [refreshToken, setRefreshToken] = useState('');
    const canReadUser = useHasPermission([USER.READ]);

    const refreshAuditLogData = () => {
        setRefreshToken(Math.random().toString());
    }

    return <View
        id={parseInt(id ?? '')}
        resourceName='System'
        nameFunction={r => r?.name}
        restEndpoint='/systemAccess'
        listUrl='/systemAccess'
        readPermissions={[SYSTEM.READ]}
        writePermissions={[SYSTEM.WRITE]}
        actions={[Edit, Delete]}
    >
        {
            ({ loading, data, canWrite, canRead, refreshData }) => <ViewLayout>
                {data.note && <NoteCard
                    columns={3}
                    restEndpoint={pathJoin('systemAccess', id)}
                    refreshData={refreshData}
                    editButton={canWrite}
                    deleteButton={canWrite}
                    title='System Note'
                >{data.note}</NoteCard>}
                <StatCard
                    title='System Info'
                    stats={{
                            'Status': loading ? <LoadText /> : <SystemStatus status={data.status} showName={true} />,
                            'Name': loading ? <LoadText /> : data.name ?? 'None',
                            'Authorized Users': loading ? <LoadText /> : data.authorizedUserCount ?? 0,
                            'IT Helpdesk Phone': loading ? <LoadText /> : data.helpITPhone ? <Telephone weight='bold' number={data.helpITPhone} extension={data.helpITPhoneExtension}  /> : 'None',
                            'Url': loading ? <LoadText /> : data.url ? <a target='_blank' rel='noopener noreferrer' href={data.url}>{data.url}</a> : 'None',
                            'Support Contact Name': loading ? <LoadText /> : data.supportContactName ?? 'None',
                            'Support Contact Email': loading ? <LoadText /> : data.supportContactEmail ? <Email weight='bold' email={data.supportContactEmail} /> : 'None',
                        }}
                />


                <AutoSizeCard
                    columns={2}
                >
                    <h1>Authorized Users</h1>
                    <AuthorizedUserList
                        refreshData={() => { refreshData(); refreshAuditLogData(); }}
                        scope={id ? parseInt(id.toString()) : null}
                    />
                </AutoSizeCard>

                {canWrite && canReadUser && <AutoSizeCard
                    columns={2}
                >
                    <h1>Audit Log</h1>
                    <AuthorizedUserAuditLog
                        refreshToken={refreshToken}
                        systemId={id ? parseInt(id.toString()) : null}
                    />
                </AutoSizeCard>}

            </ViewLayout>
        }
    </View>
}